import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ResourcesComponent } from './resources/resources.component';
import { NationalServicesModule } from './national-services/national-services.module';



@NgModule({
  declarations: [
    HomeComponent,
    ResourcesComponent
   
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HomeRoutingModule,
    MaterialModule,
    ReactiveFormsModule,
    NationalServicesModule
  ]
})
export class HomeModule { }
